import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Typography } from '@mui/material';
import axios from 'axios';
import useResponsive from '../../hooks/useResponsive';

const fetchRowList = async (uri, cb) => {
    try {
        const { data } = await axios.get(uri);
        cb(data)
    } catch (error) {
        console.log('error : ', error)
        cb({ success: false, ...error, text: error?.message || 'Some thing went wrong!' });
    }
}

export default forwardRef(({
    defaultProps, fetchBaseURI, columns, checkboxSelection, header, hide0FieldValue, cb = () => { },
    hidePagination
}, ref, id = "") => {

    const [rowList, setRowList] = useState(null);
    const [listQuery, setListQuery] = useState({ page: 0, pageSize: defaultProps?.pageSize || 10, });
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({ field: null, operator: null, value: null });
    const [sort, setSort] = useState({ field: null, sort: null });
    const { isMobile } = useResponsive();

    useEffect(() => {
        if (!fetchBaseURI) return;

        setLoading(true)

        fetchRowList(`${fetchBaseURI}page=${listQuery.page}&pageSize=${listQuery.pageSize}&sortField=${sort.field}&sortDirection=${sort.sort}&filterField=${filter.field}&filterOperator=${filter.operator}&filterValue=${filter.value}`,
            ({ success, message, data }) => {
                console.log('data : ', data);
                if (success) {
                    cb(data?.list)
                    setRowList({ list: data.list, pagination: data.pagination.totalDocuments });
                }
                setLoading(false);
            });
    }, [listQuery, filter, sort]);

    const resetList = () => {
        setListQuery({ page: 0, pageSize: defaultProps?.pageSize || 10, });
        setFilter({ field: null, operator: null, value: null });
        setSort({ field: null, sort: null });
    }

    useImperativeHandle(ref, () => ({
        refetchList: resetList
    }));
    return <>
        {header && <div className='flex justify-between items-center p-2'>
            <Typography variant="h5" gutterBottom children={header.title} />
            <div className='flex gap-2 items-center'>
                {/* <Button size='small' variant="outlined" onClick={resetList}>Reset</Button> */}
                {header?.onClick && <Button size='small' variant="contained" onClick={header.onClick}>{header.btnTitle || "Add New"}</Button>}
            </div>
        </div>}

        <DataGrid
            key={JSON.stringify(listQuery)}
            density={isMobile ? 'compact' : 'standard'}
            rows={(hide0FieldValue && rowList?.list) ? (rowList?.list?.filter(e => ((e[hide0FieldValue.key]?.length) != 0))) : (rowList?.list || [])}
            // rows={row}
            columns={columns}
            rowCount={rowList?.pagination || 0}
            paginationModel={listQuery}
            pagination
            onPaginationModelChange={setListQuery}
            getRowHeight={() => 'auto'}
            // pageSizeOptions
            loading={loading}
            getRowId={_row => _row._id}
            pageSizeOptions={isMobile ? [5, 10] : [5, 10, 25, 50]}
            checkboxSelection={checkboxSelection}
            sortingMode="server"
            filterMode="server"
            paginationMode='server'
            onFilterModelChange={({ items }) => {
                if (items[0]) {
                    const { field, operator, value } = items[0];
                    const nonValueFields = ['contains', 'equals', 'startsWith', 'endsWith', 'isAnyOf', '=', '!=', '>', '>=', '<', '<=', 'is', 'not', 'after', 'onOrAfter', 'before', 'onOrBefore'];
                    if (nonValueFields.includes(operator)) {
                        if (value) {
                            setFilter({ field, operator, value });
                        }
                    } else {
                        setFilter({ field, operator })
                    }
                }
            }}
            onSortModelChange={args => { if (args[0]) { setSort(args[0]); } }}
            // styles
            sx={{
                boxShadow: 3,
                minHeight: 300,
                height: '100%',
                width: '100%',
                '& .MuiDataGrid-virtualScroller': {
                    minHeight: 300
                },
                '& .MuiDataGrid-footerContainer': {
                    display: hidePagination ? 'none' : 'block'
                },
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0047AB',
                    '& .MuiDataGrid-columnHeader': {
                        color: '#fff',
                        fontWeight: '800',
                        '& .MuiSvgIcon-root': {
                            color: '#fff'
                        }
                    },
                },
                '& .MuiDataGrid-cell': {
                    padding: defaultProps?.rowFlex ? '10px' : '14px',
                    display: defaultProps?.rowFlex ? 'block' : 'flex',
                }
                // '& .MuiDataGrid-cell:hover': {
                //     color: 'primary.main',
                //     backgroundColor: 'blue'
                // }, 
            }}
        />
    </>
});